import MailChecker from 'mailchecker';
import { WAPHARMA_EXTRA_DISPOSABLE_DOMAINS } from './email-disposable-extra-domains.js';

/** French message returned by API and storefront when a disposable domain is rejected. */
export const DISPOSABLE_EMAIL_REJECTED_MESSAGE =
  'Adresse e-mail non acceptée. Utilisez une adresse personnelle ou professionnelle.';

const BASIC_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const extraDisposableSet = new Set<string>(WAPHARMA_EXTRA_DISPOSABLE_DOMAINS);

/** Normalize email for signup checks (lowercase, trimmed). */
export function normalizeSignupEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Host suffixes: foo.bar.com → ['foo.bar.com', 'bar.com'] */
export function emailHostSuffixes(host: string): string[] {
  const parts = host.split('.').filter(Boolean);
  if (parts.length < 2) return [host];
  const suffixes: string[] = [];
  for (let i = 0; i < parts.length - 1; i++) {
    suffixes.push(parts.slice(i).join('.'));
  }
  return suffixes;
}

function isExtraDisposableHost(host: string): boolean {
  const normalized = host.toLowerCase().trim();
  for (const suffix of emailHostSuffixes(normalized)) {
    if (extraDisposableSet.has(suffix)) return true;
  }
  return false;
}

function isDisposableSignupEmail(normalized: string): boolean {
  const host = normalized.split('@')[1];
  if (!host) return true;
  if (isExtraDisposableHost(host)) return true;
  if (!MailChecker.isValid(normalized)) return true;
  return false;
}

/** Optional e-mail field: empty is OK; non-empty must look like an address. */
export function getOptionalEmailValidationError(value: string): string | undefined {
  const v = value.trim();
  if (!v) return undefined;
  if (!BASIC_EMAIL_RE.test(v)) return 'Adresse e-mail invalide.';
  return undefined;
}

/**
 * Signup e-mail validation: format, then disposable/temp domain blocklist.
 * Returns a French error string, or undefined if allowed.
 */
export function getDisposableEmailValidationError(email: string): string | undefined {
  const normalized = normalizeSignupEmail(email);
  if (!normalized) return 'Adresse e-mail invalide.';
  if (!BASIC_EMAIL_RE.test(normalized)) return 'Adresse e-mail invalide.';
  if (isDisposableSignupEmail(normalized)) return DISPOSABLE_EMAIL_REJECTED_MESSAGE;
  return undefined;
}
